export const API_URL = 'https://api.beta3.alpitraining.com/graphql'
const LOGIN_URL = 'https://api.beta3.alpitraining.com/auth/login'

type GraphQLResponse<T> = {
  data?: T;
  errors?: { message: string }[];
};

type LoginResponse = {
  access_token: string;
  refreshToken?: string;
  user?: {
    id: string;
    email: string;
    name?: string;
  };
};

// We'll create a simple error handler that can be used with the toast context
export const handleGraphQLError = (error: any, showError?: (title: string, description?: string) => void) => {
  const errorMessage = error?.message || 'An unexpected error occurred';
  
  if (showError) {
    showError('API Error', errorMessage);
  } else {
    console.error('GraphQL Error:', errorMessage);
  }
};

export async function graphqlRequest<T = any>(
  query: string,
  variables?: Record<string, any>,
  showError?: (title: string, description?: string) => void
): Promise<T> {
  try {
    // Get auth token from localStorage if available
    const token = localStorage.getItem('authToken');
    
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };

    // Add authorization header if token exists
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(API_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({ query, variables }),
    });

    // Check if response is ok
    console.log('response', response)
    if(response.status === 201) {
      // na
    }

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      handleGraphQLError(error, showError);
      throw error;
    }

    const result: GraphQLResponse<T> = await response.json();

    if (result.errors) {
      const error = new Error(result.errors[0].message);
      handleGraphQLError(error, showError);
      throw error;
    }

    if (!result.data) {
      const error = new Error('No data received from GraphQL endpoint');
      handleGraphQLError(error, showError);
      throw error;
    }

    return result.data;
  } catch (error) {
    handleGraphQLError(error, showError);
    throw error;
  }
}

// Helper function to test GraphQL connection
export async function testGraphQLConnection(): Promise<boolean> {
  try {
    const testQuery = `
      query TestConnection {
        __typename
      }
    `;
    
    await graphqlRequest(testQuery);
    return true;
  } catch (error) {
    console.error('GraphQL connection test failed:', error);
    return false;
  }
}

export async function loginRequest(
  email: string,
  password: string,
  showError?: (title: string, description?: string) => void
): Promise<LoginResponse> {
  try {
    const response = await fetch(LOGIN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ login: email, password }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      const error = new Error(`Login failed: ${response.status} ${errorText}`);
      handleGraphQLError(error, showError);
      throw error;
    }

    const result: LoginResponse = await response.json();
    console.log('RES', result)
    if (!result.access_token) {
      const error = new Error('Login response missing access token');
      handleGraphQLError(error, showError);
      throw error;
    }

    localStorage.setItem('authToken', result.access_token);

    return result;
  } catch (error) {
    handleGraphQLError(error, showError);
    throw error;
  }
}
